import type { ProductReviewsAggregate } from '@iheartjane/dm-sdk';
import { useQuery } from '@tanstack/react-query';

import { useSDK } from '../sdkProvider';

export const useFetchProductReviewsAggregate = (
  productId: number,
  { enabled = true }: { enabled?: boolean } = {}
) => {
  const { sdk, isReady } = useSDK();

  return useQuery<ProductReviewsAggregate | undefined>({
    enabled: !!sdk && isReady && enabled,
    queryKey: ['productReviews', 'aggregate', productId],
    queryFn: async () => {
      // We only want response.aggregate (unfiltered summary + distribution),
      // not the review rows — pageSize 1 is the smallest payload the endpoint
      // returns a usable aggregate for.
      const response = await sdk!.fetchProductReviews({
        page: 1,
        pageSize: 1,
        productId,
      });
      return response.aggregate;
    },
  });
};
